import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserSupplierService } from '../../../../Services/User/Supplier/user-supplier.service';
import { NotificationService } from '../../../../Services/notification.service';

@Component({
  selector: 'app-kalakaar-reset-password',
  imports: [FormsModule],
  templateUrl: './kalakaar-reset-password.component.html',
  styleUrl: './kalakaar-reset-password.component.css'
})
export class KalakaarResetPasswordComponent implements OnChanges{

  @Input() userKalakarData: any;   // ✅ not array

  email: string = '';
  password: string = '';
  master_password: string = '';

  constructor(private userSupplierService:UserSupplierService,private notification:NotificationService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userKalakarData'] && this.userKalakarData) {
      console.log("kalakar data", this.userKalakarData);
      this.email = this.userKalakarData[0]?.email;
    }
  }

  updatePassword() {

    const formData = new FormData();

    formData.append('email', this.email);
    formData.append('password', this.password);
    formData.append('master_password', this.master_password);

    // 👇 IMPORTANT
    formData.append('_method', 'PUT');

    this.userSupplierService
      .updateUserSupplier(this.userKalakarData[0].id, formData)
      .subscribe((res: any) => {
        this.notification.showSuccess(
          "Password updated successfully",
          "success"
        );
      });
  }
}
